var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.011,
    height: 18,
    viewBox: "0 0 18.011 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "family",
    transform: "translate(-0.998 -0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64134",
    "data-name": "Path 64134",
    d: "M45.112,47.878A.347.347,0,0,1,45,48.1l.421,3.2a.988.988,0,0,1-.421.927.789.789,0,0,0,.9-.7l.478-3.933a5.709,5.709,0,0,1-1.208-.2Z",
    transform: "translate(-31.64 -33.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64135",
    "data-name": "Path 64135",
    d: "M54.073,46.9a6.009,6.009,0,0,1-1.573.309l.478,3.933a.807.807,0,0,0,1.6-.2Z",
    transform: "translate(-37.033 -33.077)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9442",
    "data-name": "Ellipse 9442",
    cx: 1.545,
    cy: 1.545,
    r: 1.545,
    transform: "translate(3.387 0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64136",
    "data-name": "Path 64136",
    d: "M6.786,24.167a3.239,3.239,0,0,1-.506-.281l.393-1.967a.666.666,0,0,1-.983-.843c0-.028,1.152-2.332,1.068-2.191a.714.714,0,0,1,.365-.337c.028-.421.169-2.276.169-2.135.028.14.084.253.112.393a1.122,1.122,0,0,1,.955-.562A15.481,15.481,0,0,0,7.6,14.165c-.759-1.658-4.916-1.292-5.478.028A13.5,13.5,0,0,0,1,18.745a.535.535,0,0,0,1.068.056,11.155,11.155,0,0,1,.421-2.444l.393,5.169c0,.084.084.14.169.169l-.59,4.945a.807.807,0,0,0,1.6.2l.59-5.141H5.1l.618,5.113a.8.8,0,0,0,1.32.506.791.791,0,0,1-.281-.59V24.167Z",
    transform: "translate(0 -8.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64137",
    "data-name": "Path 64137",
    d: "M47.178,17.167A6.623,6.623,0,0,0,46.42,15v1.1l1.011,5.113a5.831,5.831,0,0,1-4.635.646,27.36,27.36,0,0,0,.253-3.315,2.766,2.766,0,0,0,1.433-2.3.8.8,0,0,0-1.6-.14,1.261,1.261,0,0,1-.337.871c-.112-.056-.253-.112-.365-.169l.112-.59a1.44,1.44,0,0,0-.59-2.051c.7-1.377.534-1.208.815-1.377a3.87,3.87,0,0,1,3.427-.14c1.068.45,2.163,3.2,2.332,4.355A.554.554,0,0,1,47.178,17.167Z",
    transform: "translate(-29.267 -8.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64138",
    "data-name": "Path 64138",
    d: "M47.045,3.99A1.541,1.541,0,0,0,48.59,2.445a1.545,1.545,0,1,0-3.09,0A1.559,1.559,0,0,0,47.045,3.99Z",
    transform: "translate(-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64139",
    "data-name": "Path 64139",
    d: "M36.452,21.76A1.163,1.163,0,0,0,37.6,20.58a1.224,1.224,0,0,0-.674-1.068,1.323,1.323,0,0,0-.478-.112A1.139,1.139,0,0,0,35.3,20.552,1.188,1.188,0,0,0,36.452,21.76Z",
    transform: "translate(-24.665 -13.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64140",
    "data-name": "Path 64140",
    d: "M35.882,34.645l-.421-3.118-.028-.253a.121.121,0,0,0,.112-.112c.253-2.978.337-4.242.337-4.214a2.4,2.4,0,0,0,1.4-2.163.537.537,0,1,0-1.068-.112,1.438,1.438,0,0,1-.59,1.18,3.49,3.49,0,0,0-1.18-.421,1.477,1.477,0,0,1-.674,0,2.107,2.107,0,0,0-.9.281c-.337.169-.843.534-.787.871a.556.556,0,0,1,.309.309c0,.028,1.152,2.332,1.068,2.191a.655.655,0,0,1-.843.9c0,.028.084,1.236.084,1.152a.121.121,0,0,0,.112.112c-.506,3.68-.45,3.371-.45,3.371a.666.666,0,1,0,1.32.169l.281-2.079.14,1.011.14,1.124a.939.939,0,0,0,1.4.674.828.828,0,0,1-.365-.14.637.637,0,0,0,.59-.73Z",
    transform: "translate(-22.353 -16.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64141",
    "data-name": "Path 64141",
    d: "M22.4,53l.028.169v2.276a.534.534,0,0,0,1.068,0V53.253A3.869,3.869,0,0,1,22.4,53Z",
    transform: "translate(-15.389 -37.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64142",
    "data-name": "Path 64142",
    d: "M32.365,57.879c.2-.309.084-.534.112-2.079l-.2,1.545A1.185,1.185,0,0,0,32.365,57.879Z",
    transform: "translate(-22.489 -39.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64143",
    "data-name": "Path 64143",
    d: "M28.3,55.444a.534.534,0,0,0,1.068,0V53a3.486,3.486,0,0,1-1.068.253Z",
    transform: "translate(-19.632 -37.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64144",
    "data-name": "Path 64144",
    d: "M24,26.227a.927.927,0,1,0,.927-.927A.927.927,0,0,0,24,26.227Z",
    transform: "translate(-16.54 -17.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64145",
    "data-name": "Path 64145",
    d: "M22.841,37.754c0-.028-.646-3.259-.59-3.062v-.337c0,.028.59,1.208.59,1.18a.408.408,0,0,0,.73-.365c-1.152-2.332-.983-2.332-1.77-2.585-.112-.028-.2-.056-.309-.084a1.165,1.165,0,0,1-.871,0,3.331,3.331,0,0,0-.787.281.328.328,0,0,0-.169.169c-1.854,3.765.112-.225-1.068,2.191a.39.39,0,0,0,.112.478.412.412,0,0,0,.618-.14c.112-.253.562-1.152.534-1.1v.253c-.506,2.557-.618,3.09-.59,3.062A3.232,3.232,0,0,0,22.841,37.754Z",
    transform: "translate(-12.627 -22.722)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.56b5dba55847b0338b8e234399746af7.svg";
export { ForwardRef as ReactComponent };